import { React, DomeComponent, DomeManipulator } from "@lexriver/dome"
import { Settings } from "../../Settings"
import { EnumUserType } from "../enums/EnumUserType"
import { GlobalUser } from "../GlobalUser"
import { LoadingSpinnerForButton } from "./LoadingSpinnerForButton"
import css from './BasketText.m.scss'
import { ServerSettings } from "../server-queries/ServerSettings"

interface Attrs{

}

export class BasketText extends DomeComponent<Attrs>{
    render(){
        return <div class={css.container}><LoadingSpinnerForButton /></div>
    }

    protected async afterRender() {
        // console.log('3234234')
        this.scheduleUpdate()
    }

    async updateAsync(): Promise<void> {
        const userType = await GlobalUser.getUserTypeAsync()        
        //     'basket-text-wholesale' |
        //  'basket-text-retail' |
        //   'basket-text-anonymous' |
        //   'basket-text-sp' |
        //   'basket-text-administrator'

        let htmlText = ''
        if(userType === EnumUserType.Administrator){
            htmlText = await ServerSettings.getOnlyValueAsync('basket-text-administrator')
        } else if(userType === EnumUserType.Anonymous){
            htmlText = await ServerSettings.getOnlyValueAsync('basket-text-anonymous')
        } else if(userType === EnumUserType.RetailUser){
            htmlText = await ServerSettings.getOnlyValueAsync('basket-text-retail')
        } else if(userType === EnumUserType.SP){
            htmlText = await ServerSettings.getOnlyValueAsync('basket-text-sp')
        } else if(userType === EnumUserType.WholesaleUser){
            htmlText = await ServerSettings.getOnlyValueAsync('basket-text-wholesale')
        } else if(userType === EnumUserType.SMM){
            htmlText = await ServerSettings.getOnlyValueAsync('basket-text-retail')
        }

        this.rootElement.innerHTML = htmlText
        this.rootElement['style']['display'] = htmlText.trim().length==0 ? 'none' : 'block'
        // await DomeManipulator.replaceAllChildrenAsync(this.rootElement,)
    }
}
